import SessionCard from "./SessionCard";
import React, { useState, useEffect } from "react";

const UpcomingSession = () => {
  // const [completedSessions, setCompletedSessions] = useState([]);
  const [upcomingSessions, setUpcomingSessions] = useState([]);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  
  const token = localStorage.getItem("USER_AUTH_TOKEN");

  const getMeetingsData = async () => {
    try {
      const response = await fetch(
        `${baseUrl}/api/user/session/upcoming`,
        {
          method: "GET",
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        console.log(data.data);
        setUpcomingSessions(data.data);
      } else {
        console.error("Error fetching meetings data:", response.status);
      }
    } catch (error) {
      console.error("Error fetching meetings data:", error);
    }
  };

  const handleJoinClick = (name) => {
    alert(`Joining for session by ${name}`);
  };


  useEffect(() => {
    getMeetingsData();
  }, []);

  return (
    <div>
      {upcomingSessions.length === 0 ? (
        <div className="my-4 bg-blue-200 p-5 rounded-md">
          <p>Your upcoming sessions will be shown here.</p>
        </div>
      ) : (
        upcomingSessions.map((session, index) => (
          <div key={index} className="my-4 bg-blue-200 rounded-md">
            <SessionCard sessionData={session} />
            <button
              className="bg-blue-500 text-white ml-5 mb-5 px-5 py-2 rounded-lg"
              onClick={() => handleJoinClick(session.name)}
            >
              Join
            </button>
          </div>
        ))
      )}
    </div>
  );
};

export default UpcomingSession;
